<section class="bienvenida" routerLink="/evento">

    <img class="img-fluid" [src]="fondo" alt="bienvenida">

    <button appBienvenida routerLink="/evento" class="spinner-grow" role="status">
        <span class="visually-hidden">Click here!</span>
    </button>

</section>
